import { z } from "zod";

export enum RequestSourceTypeEnum {
    KLIENT = 1,
    MAKLER = 2,
    OBCHODNIK = 3,
    CALL_CENTRUM = 4
}

export const RequestSourceTypeEnumSchema = z.nativeEnum(RequestSourceTypeEnum);
export type RequestSourceTypeEnumSchema = z.infer<typeof RequestSourceTypeEnumSchema>;
